import { render } from "./time-span.vue?vue&type=template&id=c1c9ff9e"
import script from "./time-span.vue?vue&type=script&lang=js"
export * from "./time-span.vue?vue&type=script&lang=js"

import "./time-span.vue?vue&type=style&index=0&id=c1c9ff9e&lang=less"

import exportComponent from "/Users/liuyansong/Work/Vue/test/vue3-video-player/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__